import { useEffect, useState } from "react";
import { apiEndpoints, authenticatedFetch } from "../config/api";

const DashboardHome = () => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, setRecentBookings] = useState([]);

  useEffect(() => {
    const fetchDashboardData = async () => {
      setLoading(true);
      try {
        const response = await authenticatedFetch(
          apiEndpoints.dashboard.overview
        );
        if (response.ok) {
          const res = await response.json();
          const s = [
            {
              name: "Total Bookings",
              value: res.stats.totalBookings,
              change: "+12%",
              changeType: "positive",
            },
            // {
            //   name: "Revenue",
            //   value: `$${res.stats.revenue}`,
            //   change: "+8.2%",
            //   changeType: "positive",
            // },
            {
              name: "Pending Bookings",
              value: res.stats.pendingBookings,
              change: "-2.5%",
              changeType: "negative",
            },
            {
              name: "Website Visitors",
              value: res.stats.websiteVisitors,
              change: "+24%",
              changeType: "positive",
            },
            // {
            //   name: "Local Visitors",
            //   value: res.stats.localVisitors,
            //   change: "+24%",
            //   changeType: "positive",
            // },
            // {
            //   name: "Foreign Visitors",
            //   value: res.stats.foreignVisitors,
            //   change: "+24%",
            //   changeType: "positive",
            // },
          ];
          setStats(s);
          setRecentBookings(res.recentBookings);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
        setLoading(false);
      }
    };

    fetchDashboardData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <h3 className="text-2xl font-semibold text-gray-900 dark:text-white mb-6">
        Dashboard Overview
      </h3>
      {/* Loading State */}
      {loading && (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
          <span className="ml-2 text-gray-600">Loading ...</span>
        </div>
      )}

      {!loading && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {stats.map((stat, index) => {
            // Dark professional color schemes for different card types
            const cardColors = [
              {
                bg: "bg-gradient-to-br from-slate-800 to-slate-900",
                border: "border-l-4 border-blue-400",
                iconBg: "bg-blue-500",
                text: "text-blue-300",
                valueText: "text-white",
                labelText: "text-gray-300",
              },
              {
                bg: "bg-gradient-to-br from-slate-800 to-slate-900",
                border: "border-l-4 border-emerald-400",
                iconBg: "bg-emerald-500",
                text: "text-emerald-300",
                valueText: "text-white",
                labelText: "text-gray-300",
              },
              {
                bg: "bg-gradient-to-br from-slate-800 to-slate-900",
                border: "border-l-4 border-amber-400",
                iconBg: "bg-amber-500",
                text: "text-amber-300",
                valueText: "text-white",
                labelText: "text-gray-300",
              },
              {
                bg: "bg-gradient-to-br from-slate-800 to-slate-900",
                border: "border-l-4 border-purple-400",
                iconBg: "bg-purple-500",
                text: "text-purple-300",
                valueText: "text-white",
                labelText: "text-gray-300",
              },
              {
                bg: "bg-gradient-to-br from-slate-800 to-slate-900",
                border: "border-l-4 border-indigo-400",
                iconBg: "bg-indigo-500",
                text: "text-indigo-300",
                valueText: "text-white",
                labelText: "text-gray-300",
              },
              {
                bg: "bg-gradient-to-br from-slate-800 to-slate-900",
                border: "border-l-4 border-rose-400",
                iconBg: "bg-rose-500",
                text: "text-rose-300",
                valueText: "text-white",
                labelText: "text-gray-300",
              },
            ];
            
            const colors = cardColors[index % cardColors.length];
            
            return (
              <div
                key={stat.name}
                className={`${colors.bg} ${colors.border} p-6 rounded-lg shadow-2xl hover:shadow-2xl hover:scale-105 transition-all duration-300 border-t border-r border-b border-slate-700`}
              >
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <p className={`text-sm font-semibold ${colors.labelText} uppercase tracking-wide mb-2`}>
                      {stat.name}
                    </p>
                    <p className={`text-3xl font-bold ${colors.valueText} mb-3`}>
                      {stat.value}
                    </p>
                  </div>
                  <div className="flex flex-col items-end">
                    <div className={`w-12 h-12 ${colors.iconBg} rounded-lg flex items-center justify-center mb-2 shadow-lg`}>
                      <svg
                        className="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                        />
                      </svg>
                    </div>
                    <span
                      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold shadow-lg ${
                        stat.changeType === "positive"
                          ? "bg-green-600 text-white"
                          : "bg-red-600 text-white"
                      }`}
                    >
                      {stat.change}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DashboardHome;
